"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Separator_1 = require("../Separator");
var AppBarSeparator = /** @class */ (function (_super) {
    __extends(AppBarSeparator, _super);
    function AppBarSeparator() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AppBarSeparator.prototype.render = function () {
        return (React.createElement(Separator_1.default, { direction: this.props.direction, style: __assign({ margin: "10px 0" }, this.props.style) }));
    };
    AppBarSeparator.defaultProps = {
        direction: "column"
    };
    return AppBarSeparator;
}(React.Component));
exports.default = AppBarSeparator;
//# sourceMappingURL=index.js.map